function handleChooseArticleLanding() {
    const listCategoryArticle = $("#article .custom-card");

    listCategoryArticle[0].classList.add("active");

    let choosedCategory = listCategoryArticle[0].attributes.value.value;

    filterArticleByCategory(choosedCategory);

    listCategoryArticle.on("click", function () {
        choosedCategory =
            listCategoryArticle[$(listCategoryArticle).index(this)].attributes
                .value.value;

        for (let i = 0; i < listCategoryArticle.length; i += 1) {
            if (
                listCategoryArticle[i].attributes.value.value == choosedCategory
            ) {
                listCategoryArticle[i].classList.add("active");
            } else {
                listCategoryArticle[i].classList.remove("active");
            }
        }

        filterArticleByCategory(choosedCategory);
    });
}

function filterArticleByCategory(val) {
    const listArticle = $("#article .card-group .card");

    listArticle.filter(function () {
        $(this).toggle($(this)[0].attributes.value.value == val);
    });
}

function handleClickCategoryArticlePage() {
    const listArticle = $("#article .card-group .card .category-name");

    listArticle.on("click", function () {
        const pathCategoryArtikel =
            listArticle[$(listArticle).index(this)].attributes.href.value;

        window.location.href = `/articles/category/${pathCategoryArtikel}`;
    });
}

function handleDetailArticle() {
    handleClickDetailArticle('#article', '.complete-article')
    handleClickDetailArticle('#article', 'h5')
}

function handleClickDetailArticle(id, _class) {
    const article = $(`${id} ${_class}`);
    article.on("click", function () {
        window.location.href =
            article[
                $(article).index(this)
            ].attributes.href.value;
    });
}

module.exports = {
    handleChooseArticleLanding,
    handleClickCategoryArticlePage,
    handleDetailArticle,
};
